// extracted by mini-css-extract-plugin
export default {"title-section":"sYda2NOihn","titleSection":"sYda2NOihn","not-available":"vMxqekBSVY","notAvailable":"vMxqekBSVY"};